import { apiGetMe } from '../../common/api/profile'
import {
  apiRemoveSharedPresentation,
  apiCopyPresentation,
  apiMarkAsSeen,
  apiMarkAsUnseen
} from '../../common/api/lesson'

const fetchSharedPresentations = () => ({
  requestPrefix: 'SHARED_PRESENTATIONS:FETCH',
  request: () =>
    apiGetMe({
      include:
        'account.with_me_shared_presentations,account.shared_presentation.timestamps,account.shared_presentation.presentation,account.shared_presentation.presentation.names,account.shared_presentation.presentation.account.teacher_type.account.names,account.shared_presentation.presentation.account.pending_teacher_type.account.names,account.shared_presentation.details'
    })
})

const fetchSharedCounter = () => ({
  requestPrefix: 'SHARED_PRESENTATIONS:FETCH_COUNTER',
  request: () =>
    apiGetMe({
      include: 'account.with_me_shared_presentations_counter'
    })
})

const removePresentation = (presentationId, seen) => ({
  requestPrefix: 'SHARED_PRESENTATIONS:REMOVE',
  params: { id: presentationId, seen },
  request: () => apiRemoveSharedPresentation(presentationId)
})

const copyPresentation = (sharedPresentationId, actualPresentationId) => ({
  requestPrefix: 'SHARED_PRESENTATIONS:COPY',
  params: { id: sharedPresentationId },
  request: () => apiCopyPresentation(actualPresentationId)
})

const markAsSeen = id => ({
  requestPrefix: 'SHARED_PRESENTATIONS:MARK_AS_SEEN',
  params: { id },
  request: () => apiMarkAsSeen(id)
})

const markAsUnseen = id => ({
  requestPrefix: 'SHARED_PRESENTATIONS:MARK_AS_UNSEEN',
  params: { id },
  request: () => apiMarkAsUnseen(id)
})

export {
  fetchSharedPresentations,
  removePresentation,
  copyPresentation,
  fetchSharedCounter,
  markAsSeen,
  markAsUnseen
}
